import '@babel/polyfill'
import 'whatwg-fetch'
import 'promise-polyfill/src/polyfill'
import smoothscroll from 'smoothscroll-polyfill'


export function polyfillElementMethods(window) {
  const ElementPrototype = window.Element.prototype

  if (typeof ElementPrototype.matches !== 'function') {
    ElementPrototype.matches = ElementPrototype.msMatchesSelector
    || ElementPrototype.mozMatchesSelector
    || ElementPrototype.webkitMatchesSelector
    || function matches(selector) {
      const element = this
      const elements = (element.document || element.ownerDocument).querySelectorAll(selector)
      let index = 0

      while (elements[index] && elements[index] !== element) {
        ++index
      }

      return Boolean(elements[index])
    }
  }

  if (typeof ElementPrototype.closest !== 'function') {
    ElementPrototype.closest = function closest(selector) {
      let element = this

      while (element && element.nodeType === 1) {
        if (element.matches(selector)) {
          return element
        }

        element = element.parentNode
      }

      return null
    }
  }

  if (typeof ElementPrototype.remove !== 'function') {
    ((arr) => {
      arr.forEach((item) => {
        if (item.hasOwnProperty('remove')) {
          return
        }
        Object.defineProperty(item, 'remove', {
          configurable: true,
          enumerable: true,
          writable: true,
          value: function remove() {
            this.parentNode.removeChild(this)
          },
        })
      })
    })([Element.prototype, CharacterData.prototype, DocumentType.prototype].filter(Boolean))
  }

  smoothscroll.polyfill()
}
